export default {"src":"/_next/static/media/MetaMask.f9932d5f.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};